// extracted by mini-css-extract-plugin
module.exports = {"signImageContainer":"sign-image-component_signImageContainer__21Lxd"};